import React from 'react';
import ReactCard from '@jswork/react-card';
import styled from 'styled-components';

interface Alo7CardProp {
  shadowable: boolean;
  hoverable?: boolean;
  clickable?: boolean;
  [propName: string]: any;
}

const Card = styled(ReactCard)`
  border-radius: 0;
  border-bottom: 1px solid #e8e8e8;
  &:hover {
    background: ${props => (props.hoverable && '#e7f7ff') || 'none'};
  }
`;

const Alo7Card = (props: Alo7CardProp) => {
  return <Card {...props} />;
};

export default Alo7Card;
